<template>
  <header class="p-3">
    <h2>{{ $router.currentRoute.value.meta.title }}</h2>
    <hr>
  </header>
</template>

<script setup>
</script>
